// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --pink: #f2c4c4;
  --peach: #f9e1be;
  --mint: #bff1db;
  --lavender: #d5d1fd;
}

.access-denied-page {
  width: 100%;
  height: 100vh;

  display: flex;
  justify-content: center;
  align-items: center;

  overflow: hidden;

  background: #fff;

  position: relative;
}

/* Background */

.bg-shape {
  position: absolute;

  border-radius: 50%;

  filter: blur(5px);

  opacity: 0.45;

  animation: floatBlob 8s ease-in-out infinite;
}

.bg1 {
  width: 340px;
  height: 340px;

  background: var(--lavender);

  top: -120px;
  left: -120px;
}

.bg2 {
  width: 260px;
  height: 260px;

  background: var(--mint);

  bottom: -90px;
  right: -60px;

  animation-delay: 2s;
}

.bg3 {
  width: 180px;
  height: 180px;

  background: var(--peach);

  top: 120px;
  right: 80px;

  animation-delay: 4s;
}

@keyframes floatBlob {
  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-20px);
  }
}

/* Card */

.access-card {
  width: 520px;

  background: white;

  padding: 55px;

  border-radius: 30px;

  text-align: center;

  position: relative;

  z-index: 5;

  box-shadow:
    0 25px 70px rgba(0, 0, 0, 0.08),
    0 0 0 1px rgba(213, 209, 253, 0.18);
}

/* Shield */

.shield-wrapper {
  display: flex;
  justify-content: center;

  margin-bottom: 25px;
}

.shield {
  width: 180px;
  height: 180px;

  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;
}

.ring {
  position: absolute;

  width: 170px;
  height: 170px;

  border-radius: 50%;

  background: conic-gradient(
    var(--lavender),
    var(--mint),
    var(--peach),
    var(--pink),
    var(--lavender)
  );

  filter: blur(15px);

  opacity: 0.5;

  animation: spin 12s linear infinite;
}

.lock-circle {
  width: 110px;
  height: 110px;

  border-radius: 50%;

  background: white;

  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 44px;

  color: #6b63d9;

  box-shadow: 0 15px 35px rgba(213, 209, 253, 0.45);

  animation: pulse 2s ease infinite;

  position: relative;

  z-index: 2;
}

.error-code {
  font-size: 70px;

  font-weight: 800;

  letter-spacing: 4px;

  color: #6b63d9;

  margin-bottom: 8px;
}


/* Buttons */

.button-group {
  display: flex;
  justify-content: center;
  gap: 18px;
}

.custom-btn {
  display: flex;
  align-items: center;
  gap: 8px;

  padding: 12px 24px;

  border-radius: 14px;

  font-weight: 600;

  transition: 0.25s;
}

.home-btn {
  background: var(--lavender);

  border: none;
}

.home-btn:hover {
  background: #d5d1fd;

  transform: translateY(-2px);
}

.btn-light {
  border: 1px solid #ddd;
}

.btn-light:hover {
  background: #fafafa;

  transform: translateY(-2px);
}

/* Animations */

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.08);
  }
}

@media (max-width: 768px) {
  .access-card {
    width: 90%;
    padding: 40px 28px;
  }

  .error-code {
    font-size: 54px;
  }

  .button-group {
    flex-direction: column;
  }

  .custom-btn {
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AccessDenied.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;;EAEb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,gBAAgB;;EAEhB,gBAAgB;;EAEhB,kBAAkB;AACpB;;AAEA,eAAe;;AAEf;EACE,kBAAkB;;EAElB,kBAAkB;;EAElB,iBAAiB;;EAEjB,aAAa;;EAEb,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,aAAa;;EAEb,2BAA2B;;EAE3B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;;EAEb,uBAAuB;;EAEvB,aAAa;EACb,YAAY;;EAEZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;;EAEb,wBAAwB;;EAExB,UAAU;EACV,WAAW;;EAEX,mBAAmB;AACrB;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA,SAAS;;AAET;EACE,YAAY;;EAEZ,iBAAiB;;EAEjB,aAAa;;EAEb,mBAAmB;;EAEnB,kBAAkB;;EAElB,kBAAkB;;EAElB,UAAU;;EAEV;;uCAEqC;AACvC;;AAEA,WAAW;;AAEX;EACE,aAAa;EACb,uBAAuB;;EAEvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;;EAEb,kBAAkB;;EAElB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;;EAElB,YAAY;EACZ,aAAa;;EAEb,kBAAkB;;EAElB;;;;;;GAMC;;EAED,kBAAkB;;EAElB,YAAY;;EAEZ,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,aAAa;;EAEb,kBAAkB;;EAElB,iBAAiB;;EAEjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,eAAe;;EAEf,cAAc;;EAEd,iDAAiD;;EAEjD,iCAAiC;;EAEjC,kBAAkB;;EAElB,UAAU;AACZ;;AAEA;EACE,eAAe;;EAEf,gBAAgB;;EAEhB,mBAAmB;;EAEnB,cAAc;;EAEd,kBAAkB;AACpB;;;AAGA,YAAY;;AAEZ;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;;EAER,kBAAkB;;EAElB,mBAAmB;;EAEnB,gBAAgB;;EAEhB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;;EAE3B,YAAY;AACd;;AAEA;EACE,mBAAmB;;EAEnB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;;EAEnB,2BAA2B;AAC7B;;AAEA,eAAe;;AAEf;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;;IAEE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[":root {\n  --pink: #f2c4c4;\n  --peach: #f9e1be;\n  --mint: #bff1db;\n  --lavender: #d5d1fd;\n}\n\n.access-denied-page {\n  width: 100%;\n  height: 100vh;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  overflow: hidden;\n\n  background: #fff;\n\n  position: relative;\n}\n\n/* Background */\n\n.bg-shape {\n  position: absolute;\n\n  border-radius: 50%;\n\n  filter: blur(5px);\n\n  opacity: 0.45;\n\n  animation: floatBlob 8s ease-in-out infinite;\n}\n\n.bg1 {\n  width: 340px;\n  height: 340px;\n\n  background: var(--lavender);\n\n  top: -120px;\n  left: -120px;\n}\n\n.bg2 {\n  width: 260px;\n  height: 260px;\n\n  background: var(--mint);\n\n  bottom: -90px;\n  right: -60px;\n\n  animation-delay: 2s;\n}\n\n.bg3 {\n  width: 180px;\n  height: 180px;\n\n  background: var(--peach);\n\n  top: 120px;\n  right: 80px;\n\n  animation-delay: 4s;\n}\n\n@keyframes floatBlob {\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n\n  50% {\n    transform: translateY(-20px);\n  }\n}\n\n/* Card */\n\n.access-card {\n  width: 520px;\n\n  background: white;\n\n  padding: 55px;\n\n  border-radius: 30px;\n\n  text-align: center;\n\n  position: relative;\n\n  z-index: 5;\n\n  box-shadow:\n    0 25px 70px rgba(0, 0, 0, 0.08),\n    0 0 0 1px rgba(213, 209, 253, 0.18);\n}\n\n/* Shield */\n\n.shield-wrapper {\n  display: flex;\n  justify-content: center;\n\n  margin-bottom: 25px;\n}\n\n.shield {\n  width: 180px;\n  height: 180px;\n\n  position: relative;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.ring {\n  position: absolute;\n\n  width: 170px;\n  height: 170px;\n\n  border-radius: 50%;\n\n  background: conic-gradient(\n    var(--lavender),\n    var(--mint),\n    var(--peach),\n    var(--pink),\n    var(--lavender)\n  );\n\n  filter: blur(15px);\n\n  opacity: 0.5;\n\n  animation: spin 12s linear infinite;\n}\n\n.lock-circle {\n  width: 110px;\n  height: 110px;\n\n  border-radius: 50%;\n\n  background: white;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  font-size: 44px;\n\n  color: #6b63d9;\n\n  box-shadow: 0 15px 35px rgba(213, 209, 253, 0.45);\n\n  animation: pulse 2s ease infinite;\n\n  position: relative;\n\n  z-index: 2;\n}\n\n.error-code {\n  font-size: 70px;\n\n  font-weight: 800;\n\n  letter-spacing: 4px;\n\n  color: #6b63d9;\n\n  margin-bottom: 8px;\n}\n\n\n/* Buttons */\n\n.button-group {\n  display: flex;\n  justify-content: center;\n  gap: 18px;\n}\n\n.custom-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  padding: 12px 24px;\n\n  border-radius: 14px;\n\n  font-weight: 600;\n\n  transition: 0.25s;\n}\n\n.home-btn {\n  background: var(--lavender);\n\n  border: none;\n}\n\n.home-btn:hover {\n  background: #d5d1fd;\n\n  transform: translateY(-2px);\n}\n\n.btn-light {\n  border: 1px solid #ddd;\n}\n\n.btn-light:hover {\n  background: #fafafa;\n\n  transform: translateY(-2px);\n}\n\n/* Animations */\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes pulse {\n  0%,\n  100% {\n    transform: scale(1);\n  }\n\n  50% {\n    transform: scale(1.08);\n  }\n}\n\n@media (max-width: 768px) {\n  .access-card {\n    width: 90%;\n    padding: 40px 28px;\n  }\n\n  .error-code {\n    font-size: 54px;\n  }\n\n  .button-group {\n    flex-direction: column;\n  }\n\n  .custom-btn {\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
